"use client"

import Link from "next/link";
import React from "react";

const PROFESSIONAL_SIGNUP_ENABLED = process.env.NEXT_PUBLIC_ENABLE_PROFESSIONAL_SIGNUP !== 'false';

export default function Participar() {
    return (
        <div className="w-full min-h-screen flex items-center justify-center flex-col gap-20 bg-[url(/estrelas.png)] bg-cover py-5">
            <h1 className="laptop:text-5xl text-2xl font-bold text-[#F6F6F9] text-center px-5">Escolha como deseja participar do Sameca</h1>
            <div className="flex laptop:gap-32 gap-16 flex-wrap items-center justify-center px-4 text-center">
                <div className="bg-background laptop:w-[496px] laptop:h-[362px] p-6 border border-border-strong rounded-2xl flex flex-col items-center justify-between">
                    <div className="flex flex-col items-center gap-3">
                        <img src="/Samuca/pfp/avatar_paciente_transparente.png" alt="Samuca vestido de paciente" className="w-32 h-32" />
                        <h3 className="text-2xl font-semibold">
                            Seja um paciente
                        </h3>
                    </div>
                    <div className="p-4 text-text-sub_base">
                        <h4>
                            Receba atendimento acolhedor e humanizado, fazendo parte da nossa rede que cuida de você com atenção e respeito.
                        </h4>
                    </div>
                    <Link
                        href="/participar/paciente"
                        className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-semibold transition-all select-none focus:ring-[2px] focus:ring-offset-[3px] focus:ring-accent focus:outline-none focus:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 bg-primary text-[#F6F6F9] dark:text-[#1D222D] hover:opacity-75 w-full"
                        title="Ir para o cadastro de paciente"
                    >
                        Cadastro de paciente
                    </Link>
                </div>
                <div className="bg-background laptop:w-[496px] laptop:h-[362px] p-6 border border-border-strong rounded-2xl flex flex-col items-center justify-between">
                    <div className="flex flex-col items-center gap-3">
                        <img src="/Samuca/pfp/avatar_profissional_transparente.png" alt="Samuca vestido de profissional" className="w-32 h-32" />
                        <h3 className="text-2xl font-semibold">
                            Atenda pela Sameca
                        </h3>
                    </div>
                    <div className="p-4 text-text-sub_base">
                        <h4>
                            Contribua para ampliar o acesso a cuidados em saúde e bem-estar, fazendo parte da nossa rede de profissionais que acolhe e transforma vidas.
                        </h4>
                    </div>
                    {PROFESSIONAL_SIGNUP_ENABLED ? (
                        <Link
                            href="/primeiros-passos/profissional"
                            className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-semibold transition-all select-none focus:ring-[2px] focus:ring-offset-[3px] focus:ring-accent focus:outline-none focus:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 bg-primary text-[#F6F6F9] dark:text-[#1D222D] hover:opacity-75 w-full"
                            title="Ir para o cadastro de profissional"
                        >
                            Cadastro de profissional
                        </Link>
                    ) : (
                        <p className="text-sm text-text-sub_base text-center w-full px-2">
                            Cadastros de profissionais temporariamente suspensos.
                        </p>
                    )}
                </div>
            </div>
        </div>
    )
}